import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Habilidades</h2>
              <p>
                Como Ingeniero de Sistemas, desarrollador web y diseñador UI/UX,
                mi enfoque está en crear experiencias digitales que sean
                funcionales, atractivas y centradas en el usuario. Mis
                habilidades abarcan desde el desarrollo de interfaces intuitivas
                hasta la implementación de soluciones técnicas efectivas.
                Además, cuento con experiencia en herramientas de diseño como
                Figma, Adobe Suite y plataformas de desarrollo como React.js y
                Playwright, lo que me permite aportar valor en todas las etapas
                de un proyecto digital, desde la conceptualización hasta la
                entrega final. Mi objetivo es siempre superar expectativas,
                encontrar soluciones creativas a los desafíos y seguir
                aprendiendo para mantenerme al día con las tendencias
                tecnológicas.
                <br></br> Lorem Ipsum has been the industry's standard dummy
                text.
              </p>

              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Desarrollo Web</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>Edición De Videos</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Diseño UI/UX</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Diseño Web</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Testing y pruebas de automatización</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};
